/* eslint-disable max-len, max-lines */
import {getContent, getPatchNote, PatchNote, PatchNoteContent, PatchNoteType} from './UIPatchNoteModule'
// import AnnouncementColonistTournament from '@static/images/announcement_colonist_tournament.png'
// import AnnouncementGift from '@static/images/announcement_gift.png'
// import DangFixPixelatedFullscreenPopupImageBefore from '@static/images/patch_notes_images/dang-fix-pixelated-fullscreen-popup-image-before.png'
// import DangFixPixelatedFullscreenPopupImageAfter from '@static/images/patch_notes_images/dang-fix-pixelated-fullscreen-popup-image-after.png'
// import DangUpdatePaymentSuccessfulPopupBefore from '@static/images/patch_notes_images/dang-update-payment-successful-popup-before.png'
// import DangUpdatePaymentSuccessfulPopupAfter from '@static/images/patch_notes_images/dang-update-payment-successful-popup-after.png'

// import StanFixSafariLowResolutionDiceBefore from '@static/images/patch_notes_images/stan-fix-safari-low-resolution-dice-before.jpg'
// import StanFixSafariLowResolutionDiceAfter from '@static/images/patch_notes_images/stan-fix-safari-low-resolution-dice-after.jpg'
// import MuhammadRenameLobbyToRoomsBefore from '@static/images/patch_notes_images/rename-lobby-to-rooms-before.png'
// import MuhammadRenameLobbyToRoomsAfter from '@static/images/patch_notes_images/rename-lobby-to-rooms-after.png'
// import MuhammadFixUsernameAvatarNotShowingInChatBefore from '@static/images/patch_notes_images/message-appears-without-username-avatar-before.png'
// import MuhammadFixUsernameAvatarNotShowingInChatAfter from '@static/images/patch_notes_images/message-appears-without-username-avatar-after.png'

export class PatchNoteData {
    protected readonly patchNotes: PatchNote[]
    protected readonly announcement: string[]

    constructor() {
        this.patchNotes = []
        this.announcement = []

        this.announcement.push('<b>JOIN THIS WEEKEND\'S COLONIST QUALIFIER!!! <a href="https://tinyurl.com/colonist4ptourney49" target="_blank">REGISTER HERE</a></b>')
        // this.announcement.push(`<a href="/championship" target="_blank"><img src="${AnnouncementColonistTournament}" style="width: 100%"></a>`)
        // this.announcement.push(`<a href="https://www.youtube.com/@colonistio/?sub_confirmation=1" target="_blank"><img src="${AnnouncementColonistCon24}" style="width: 100%"></a>`)
        // this.announcement.push('Check out our latest video! </b><a href="https://youtu.be/R_hl_CAefrg" target="_blank">1 v 1 Guide!</a>!</b>')
        // this.announcement.push('<iframe style="display: block; margin: 0 auto;" width="560" height="315" src="https://www.youtube.com/embed/xtkDDYhfMHw?si=CugURvk5342Fyj02" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>')
        // this.announcement.push('<b>We are looking for a Community Manager. Check out <a href="/careers" target="_blank">careers</a>!</b>')
        // this.announcement.push(`<a href="https://blog.colonist.io/colonist-io-2023-summary/"><img src="${Announcement2023YearlyStats}" style="width: 100%"></a>`)
        // this.announcement.push(`<a href="/store#gift"><img src="/${AnnouncementGift}" style="width: 100%"></a>`)

        // Jeff

        // Andre

        // Rob

        // Oguz

        // Muhammad

        // Marc

        // Dang

        // ! PUBLIC PN FORMAT: vxxx.push(getContent(PatchNoteType.xxx, 'Description', ['Thanks to'], 'Before .png', 'After .png', ['FeatureUpvote link']))

        const v294: PatchNoteContent[] = []
        v294.push(getContent(PatchNoteType.Fix, 'Minor bug fixes and internal improvements'))
        v294.push(getContent(PatchNoteType.Fix, 'Enhanced platform stability'))

        // Oguz
        // Remove Colonist Rush Bot Game Tab CTA AB Test
        // Removed Colonist Rush Beta tag

        // Marc
        // update link to colonist in-game commands in docs
        // handle new error code 50278 from Discord API

        // Dang
        // React Refactor - Build React SeasonProgress component
        // Fix CI failed tests due to visitor table partitions

        this.patchNotes.push(getPatchNote(2025, 3, 3, 294, v294))

        const v293: PatchNoteContent[] = []
        v293.push(getContent(PatchNoteType.Update, 'Added a notification to inform users when they are muted for abusing chat', undefined, undefined, undefined))
        v293.push(getContent(PatchNoteType.Update, 'Increased Shuffle Rush turn timer from 5s to 10s'))
        v293.push(getContent(PatchNoteType.Update, 'Improved page scrolling', undefined, '/v293/page_scrolling_before.png', '/v293/page_scrolling_after.png'))
        v293.push(getContent(PatchNoteType.Update, 'New Leaderboards icon', undefined, '/v293/new_leaderboard_icon_before.png', '/v293/new_leaderboard_icon_after.png'))
        v293.push(getContent(PatchNoteType.Fix, 'Fixed reconnect banner not showing on some pages'))

        // Rob
        // Make Shuffle Queue and Setting tables visible in Colonist-Limited on Metabase
        // Prevent banned users from deleting their accounts
        // Fixed HTML tag in content_terms_of_service.ejs
        // Add Metabase Query Agent to docs

        // Stan
        // Set CODEOWNERS package.json and webpack.config.ts to @rgsthethird (previously @StanFlint)

        // Muhammad
        // remove shuffle banners (marketing test over)
        // update web sidebar & mobile bottom nav leaderboard icon
        // update profilepage banner to become a member
        // update padding and scrolling on singleton pages
        // update design tool assets doc to use 64x64px square icons
        // update careers page hero section
        // shuffle rush speed from 5s to 10s
        // add backend game count check for shuffle queue eligibility

        // Marc
        // fix leaderboard scrolling

        // Dang
        // React Refactor - Move Dialog component to Shared React UI package
        // React Refactor - Move Dropdown component to Shared React UI package
        // React Refactor - Move Button component to Shared React UI package
        // React Refactor - Move Tooltip component to Shared React UI package
        // React Refactor - Build React SeasonProgress component
        // React Refactor - Integrate new SeasonProgress component to Leaderboard page

        // Devyesh
        // [Mobile] Implement auto-deploy apps workflow

        this.patchNotes.push(getPatchNote(2026, 2, 24, 293, v293))

        const v292: PatchNoteContent[] = []
        v292.push(getContent(PatchNoteType.Update, '[Mobile] Info popup can now be accessed straight from the header', undefined, '/v292/portrait_new_top_bar_before.png', '/v292/portrait_new_top_bar_after.png'))

        // Oguz
        // Replace Bot Game Tab CTA AB Test with v2

        // Marc
        // Add on mobile the possibility to share game results on game end screen
        // Add shuffle banners back
        // Fix padding on mobile for mode/map selector cards
        // v291.push(getContent(PatchNoteType.Fix, '[Web] Fixed bug where user could not accept game invite from notification panel'))

        // Dang
        // React Refactor - Set up common styles for @colonist/ui package
        // React Refactor - Move Spinner component to Shared React UI package
        // Setup new starting packages folders for React Refactor

        // Efe
        // Tweak notification badge spacing in header so blue dot doesn’t touch sidebar

        this.patchNotes.push(getPatchNote(2026, 2, 17, 292, v292))

        const v291: PatchNoteContent[] = []
        v291.push(getContent(PatchNoteType.Blog, 'Colonist 2025 Summary! <a href="https://blog.colonist.io/colonist-io-2025-summary/" target="_blank">Read here!</a>', undefined, undefined, undefined, ['https://blog.colonist.io/colonist-io-2025-summary/']))

        // Jeff
        // Cleaned up SeasonPlayerEntityService.refreshSeason to avoid hard coded elo types.

        // Rob
        // Make Shuffle Queue and Setting tables visible in Colonist-Limited on Metabase
        // Prevent banned users from deleting their accounts
        // Fixed HTML tag in content_terms_of_service.ejs

        // Muhammad
        // rename standard -> base on shuffle card
        // fix padding on mode selector badge

        // Marc
        // Fix padding on I'm Ready checkbox in room
        // Fix padding on Become a Member popup

        this.patchNotes.push(getPatchNote(2026, 2, 10, 291, v291))

        const v290: PatchNoteContent[] = []
        v290.push(getContent(PatchNoteType.Update, 'Colonist Rush Free Beta period has ended', undefined, undefined, undefined))

        // Jeff
        // Block banned users from seeing replay data
        // Added framework to handle game state migrations. No migrations added yet.

        // Rob
        // Make Shuffle Queue and Setting tables visible in Colonist-Limited on Metabase

        // Oguz
        // Fixed /banmostreportedplayers command punishing players for the same offence multiple times

        // Marc
        // Update Shuffle Queue Rush play time to 10 minutes

        // Dang
        // v290.push(getContent(PatchNoteType.Fix, '[Discord Mobile] Fix issue unable to click I\'m Ready button', undefined, undefined, undefined))
        // React Refactor - Move and Refactor Storybook to apps/storybook
        // React Refactor - Move T component to Shared React UI package
        // Setup new starting packages folders for React Refactor
        // Fix failing CI tests
        // Fix IOS broken when MobileEnableNativePayments is enabled

        this.patchNotes.push(getPatchNote(2026, 2, 4, 290, v290))

        // Efe
        // Removed rounded corners from the right sidebar menu (Rules, FAQ, etc.)

        // Efe
        // Updated Rules sidebar: consistent hover style and no unique background on first item

        const v289: PatchNoteContent[] = []

        v289.push(getContent(PatchNoteType.Update, '<a href="/championship2026" target="_blank">Colonist Championship 2026</a> is confirmed! More details coming this April!'))
        v289.push(getContent(PatchNoteType.Update, 'Updated payment successful popup UI', undefined, '/v289/update_payment_successful_popup_before.png', '/v289/update_payment_successful_popup_after.png'))
        v289.push(getContent(PatchNoteType.Update, 'Grouped the unlocked maps & game modes together', undefined, '/v289/group_owned_maps_before.png', '/v289/group_owned_maps_after.png'))
        v289.push(getContent(PatchNoteType.Update, '"Lobby" is now called "Rooms"', undefined, '/v289/rename_lobby_to_room_before.png', '/v289/rename_lobby_to_room_after.png'))
        v289.push(getContent(PatchNoteType.Fix, 'Fixed username/icon not showing in chat sometimes', undefined, '/v289/message_appears_without_username_avatar_before.png', '/v289/message_appears_without_username_avatar_after.png'))
        v289.push(getContent(PatchNoteType.Fix, 'Fixed pixelated fullscreen popup image', undefined, '/v289/fix_pixelated_fullscreen_popup_before.png', '/v289/fix_pixelated_fullscreen_popup_after.png'))

        // Oguz
        // Update mute punishment column types to match the production database, and fix max mute amount to be 999

        // Muhammad
        // remove team values doc; now on /values page
        // move team values examples doc to /values-examples page
        // use new badge components across the app
        // refactor codebase from $padding-x & magic numbers to $space-x
        // fix badges on cc26 page

        // Marc
        // Remove AB Test to reactivate Discord inactive users

        // Dang
        // Sort Rush mode rooms to the top of Lobby room list
        // v289.push(getContent(PatchNoteType.Fix, 'Fixed pixelated fullscreen popup image', undefined, DangFixPixelatedFullscreenPopupImageBefore, DangFixPixelatedFullscreenPopupImageAfter))
        // v288.push(getContent(PatchNoteType.Update, 'Update payment successful popup UI', undefined, DangUpdatePaymentSuccessfulPopupBefore, DangUpdatePaymentSuccessfulPopupAfter))

        // Devyesh
        // Fixing loading on mobile, test servers

        // William
        // Added spinner to patch note image popup

        this.patchNotes.push(getPatchNote(2026, 1, 27, 289, v289))

        const v288: PatchNoteContent[] = []

        v288.push(getContent(PatchNoteType.Update, 'Added 15s turn timer setting and removed 240s turn timer setting from rooms', undefined, undefined, undefined))
        v288.push(getContent(PatchNoteType.Fix, '[Rush] Fixed road building error message showing for the wrong player', undefined, undefined, undefined))
        v288.push(getContent(PatchNoteType.Fix, 'Fixed "New" badge always showing for logged in users', undefined, '/v288/new_badge_before.png', '/v288/new_badge_after.png'))
        v288.push(getContent(PatchNoteType.Fix, 'Submitting a trade no longer closes the trade panel'))
        v288.push(getContent(PatchNoteType.Fix, 'Fixed not being able to re-enter fullscreen after exiting with ESC key'))

        // Oguz
        // Created A/B Test for Colonist Rush in bot games tab

        // Stan
        // [Discord Mobile] Fixed assets not loading in portrait mode
        // Add analytic event for getReplayDataFromGameId API call

        // Muhammad
        // exclude earth and uk maps from shuffle queue if not seafarers mode
        // remove mobile push notification room commands
        // change shuffle rush time to 5s and discard limit to 9

        // Marc
        // Add referral program on Web and Mobile (AB tested)

        // Dang
        // Add /toggleabtest chat command to toggle global AB tests
        // v288.push(getContent(PatchNoteType.Fix, 'Submitting a trade no longer closes the trade panel'))
        // v288.push(getContent(PatchNoteType.Fix, 'Fixed not being able to re-enter fullscreen after exiting with ESC key'))

        // Devyesh
        // Referral type enums renamed (DB migration)

        // Andrew
        // Update adblock popups wording

        this.patchNotes.push(getPatchNote(2026, 1, 20, 288, v288))

        const v287: PatchNoteContent[] = []

        v287.push(getContent(PatchNoteType.Update, 'Colonist Championship 2025 is over! Check the results in the <a href="/championship2025" target="_blank">CC25 page</a>!'))
        v287.push(getContent(PatchNoteType.Update, 'Clicking "Play Again" after a bot game immediately starts a new game, instead of creating a lobby'))
        v287.push(getContent(PatchNoteType.Update, '[Mobile] Slightly increased Game End screen button and text sizes', undefined, '/v287/mobile_endgame_before.png', '/v287/mobile_endgame_after.png'))
        v287.push(getContent(PatchNoteType.Fix, 'Fixed game counts to unlock Ranked'))
        v287.push(getContent(PatchNoteType.Fix, 'Fixed low resolution dice on iPhone/Mac', undefined, '/v287/ios_dice_resolution_before.png', '/v287/ios_dice_resolution_after.png'))

        // Stan
        // [Discord] Added feature flag to set the orientation of the Discord Embedded Activity SDK
        // Add more details to discard invalid cards internal logs
        // Make rush5s the default speed setting for rush mode

        // Muhammad
        // fix slow loading for casual/ranked cards for logged out users
        // update shuffle mode details page
        // remove membership banner ad from mobile mainpage
        // update details page margins
        // add bot game option when making a shuffle queue

        // Dang
        // Fix missing linking account error popup
        // Add 1 second delay to matchmaking requests

        // Devyesh
        // [Mobile] Upgraded the IAP version
        // [Mobile] Added support for IAP for Coins and Gifts in Android
        // ]Mobile] Added support fot IAP for Memberships in Android
        // [Mobile] Add support to test IAP for internal users

        this.patchNotes.push(getPatchNote(2026, 1, 13, 287, v287))

        const v286: PatchNoteContent[] = []

        v286.push(getContent(PatchNoteType.Update, '[Colonist Rush] Updated the default speed setting in rooms to 10s', undefined, undefined, undefined))
        v286.push(getContent(PatchNoteType.Update, 'Removed confirmation popup when kicking a bot from lobby', undefined, '/v286/bot_kick_confirmation_before.png', undefined))
        v286.push(getContent(PatchNoteType.Update, 'Simplify slider text for guests', undefined, '/v286/room_guests_before.png', '/v286/room_guests_after.png'))

        // Jeff
        // Update rematch database game type so it gets tagged correctly as a "CreateRoomGame"

        // Rob
        // HOTFIX: Allow users to CK dice roll after using dice roll free play

        // Muhammad
        // remove mobile become a member banner ab test (always show)
        // remove landing page header ab test
        // Added shuffle queue bias for 6&8 player modes and gold/fog maps

        this.patchNotes.push(getPatchNote(2026, 1, 6, 286, v286))

        const v285: PatchNoteContent[] = []
        v285.push(getContent(PatchNoteType.Fix, 'Fixed game-breaking bug when using Road Building with only one road left in Rush', undefined, undefined, undefined))

        // Juan
        // Added CC25 winner profile badge

        // Marc
        // Track performance of mobile push notification used for reactivation

        // Dang
        // Fix whole page broken for returning users who have not logged in for 30 days
        // [Mobile] Implement A/B test for mobile my turn push notification

        this.patchNotes.push(getPatchNote(2025, 12, 30, 285, v285))

        const v284: PatchNoteContent[] = []
        v284.push(getContent(PatchNoteType.Fix, 'Fixed inverted order of resource cards on trade counter offers created by current player', undefined, '/v284/trade_counter_offer_before.png', '/v284/trade_counter_offer_after.png'))
        v284.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed status bar appearing unexpectedly on some Android devices', undefined, '/v284/android_status_bar_before.png', '/v284/android_status_bar_after.png'))
        v284.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed counter offer panel extending beyond screen with 8 players', undefined, '/v284/counter_offer_8p_before.png', '/v284/counter_offer_8p_after.png'))
        v284.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed outdated C&K City Improvement colors in player info boxes', undefined, '/v284/city_improvement_mobile_before.png', '/v284/city_improvement_mobile_after.png'))

        // Rob
        // HOTFIX: Error handling for service worker caching
        // CK Monetization Test v3: 5 Free Plays/Dice Rolls

        // Oguz
        // Refactored auto-mute system to use an easier curve for calculating the number of games to mute, good behavior over time is rewarded, and /unmute command now deletes all mute entries.

        // Muhammad
        // fix ads not showing on hexs.io
        // hide external lobby ads for users who have played less than 5 games (shows private ads instead)

        this.patchNotes.push(getPatchNote(2025, 12, 23, 284, v284))

        const v283: PatchNoteContent[] = []
        v283.push(getContent(PatchNoteType.Update, '[Mobile] Achievement popup is below player information container', undefined, '/v283/stop-achievements-blocking-before.png', '/v283/stop-achievements-blocking-after.png'))
        v283.push(getContent(PatchNoteType.Update, 'Updated Shuffle mode card UI', undefined, '/v283/shuffle_card_before.png', '/v283/shuffle_card_after.png'))
        v283.push(getContent(PatchNoteType.Fix, 'Fixed shifting content when switching between tabs', undefined, '/v283/shifting_content_before.png', '/v283/shifting_content_after.png'))
        v283.push(getContent(PatchNoteType.Fix, 'Fixed inconsistent gaps between chat, logs, and bank containers'))

        // Rob
        // Shuffle 1v1 games have 15 VPs

        // Oguz
        // Made map corners and edges clickable even when the action is not available on mobile
        // Removed Bot Speed from in-game settings page and from profile game history
        // Renamed GameSpeedSettings enum values to match new turn timer settings
        // Added allowedGameTimers to GameModeData and the GameTimerOption interface
        // v283.push(getContent(PatchNoteType.Fix, 'Fixed the inverted trade resources in counter offers created by the current turn player', undefined, undefined, undefined))

        // Stan
        // [Rush] Fixed trade creator offered cards not updating after monopoly card usage
        // Achievement popup click to dismiss
        // Hide the end screen replay share button in portrait if no replay is available
        // Remove unused UIGameAvatarWithCards component (leftover from ReactJS refactor)
        // [Rush] Replaced "Alpha" with "Beta" branding
        // [Rush] Increased visibility of Rush map bottom logo

        // Muhammad
        // update shuffle queue free games badge
        // remove icons from landing page social proof
        // select mode selector card from matchmaking queue url parameter
        // update language button ui in mobile menu and add to web
        // updated design for mode selector tabs
        // fix bot section briefly showing before localstorage is loaded
        // move shuffle data out of clientuserstate

        // Dang
        // [Mobile] Update annual membership prices for Android
        // Move redirection logic for old account from client to server
        // Fix city improvement tracker icon size and alignment in action button
        // [Mobile Web] Fix Rulebook redirection for Guest user
        // [Mobile] Force portrait mode for returning mobile app players whose last session was more than 30 days ago
        // [Mobile] Fix counter-offer UI goes off-screen in 8-player games

        // Devyesh

        // Sinan
        // v283.push(getContent(PatchNoteType.Update, 'Membership plan pricing tab UI updated to take the full width', undefined, 'https://imgur.com/a/DBl9EjE', 'https://imgur.com/a/2mAYODe'))

        // ! PUBLIC PN FORMAT: vxxx.push(getContent(PatchNoteType.xxx, 'Description', ['Thanks to'], 'Before .png', 'After .png', ['FeatureUpvote link']))

        this.patchNotes.push(getPatchNote(2025, 12, 16, 283, v283))
    }

    getContributionCount(username: string): number {
        let count = 0
        for(const pn of this.getAll()) {
            for(const content of pn.contents) {
                for(const contributor of content.contributors) {
                    if(contributor == username) count += 1
                }
            }
        }
        return count
    }

    getAnnouncements(): string[] {
        return this.announcement
    }

    getAll(): PatchNote[] {
        return this.patchNotes
    }

    getLast5(): PatchNote[] {
        return this.patchNotes.slice(0, 5)
    }

    getLatest(): PatchNote[] {
        return this.patchNotes.slice(0, 1)
    }
}
